/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import "./Web192023.css";

function Web192023(props) {
  const { x36345580381_68E41A943C_K, group138, path128 } = props;

  return (
    <div className="container-center-horizontal">
      <div className="web-1920-23 screen">
        <div className="overlap-group1-24">
          <img className="x36345580381_68e41a943c_k-1" src={x36345580381_68E41A943C_K} />
          <div className="rectangle-2-42 border-1px-dove-gray"></div>
          <div className="overlap-group-50">
            <div className="group-141-9">
              <div className="group-140-9">
                <div className="group-139-9">
                  <img className="group-138-9" src={group138} />
                </div>
              </div>
            </div>
            <img className="path-128-10" src={path128} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Web192023;
